<template>
  <el-card>
    <div
      slot="header"
      class="clearfix"
    >
      <span>Készletáthelyezés kérelmek</span>
    </div>
    <div v-loading="loading" style="min-height: 81px;">
      <table-filter
        v-if="filterConfig"
        :config="filterConfig"
        action="representativeTransferRequest/fetchAll"
      />
    </div>
    <representative-transfer-request-list />
    <template v-if="$route.meta.showViewRepresentativeTransferRequestDialog">
      <representative-transfer-request-dialog
        :representative-transfer-request-id="$route.params.id"
      />
    </template>
  </el-card>
</template>

<script>
  import RepresentativeTransferRequestList from '../../components/representativeProcesses/representativeTransferRequests/List';
  import TableFilter from '../../components/TableFilter';
  import RepresentativeTransferRequestDialog from '../../components/representativeProcesses/representativeTransferRequests/Dialog';

  export default {
    components: {
      RepresentativeTransferRequestList,
      TableFilter,
      RepresentativeTransferRequestDialog,
    },
    data() {
      return {
        loading: false,
        filterConfig: null,
      };
    },
    async mounted() {
      this.loading = true;
      await this.setConfig();
      this.loading = false;
    },
    methods: {
      async setConfig() {
        let users = this.$store.getters['user/users'];
        if (!users.length) {
          await this.$store.dispatch('user/fetchAll');
          users = this.$store.getters['user/users'];
        }
        this.filterConfig = [
          {
            type: 'select',
            options: [
              {
                label: 'Nyitott',
                status: 'open'
              },
              {
                label: 'Elutasítva',
                status: 'refused'
              },
              {
                label: 'Teljesítve',
                status: 'completed'
              },
            ],
            name: 'status',
            label: 'Státusz',
            labelCallback: status => status.label,
            valueKey: 'status',
          },
          {
            type: 'select',
            options: users,
            name: 'sourceUser',
            label: 'Átadó',
            labelCallback: user => user && user.full_name || '',
            valueKey: 'id',
          },
          {
            type: 'select',
            options: users,
            name: 'targetUser',
            label: 'Átvevő',
            labelCallback: user => user && user.full_name || '',
            valueKey: 'id',
          },
        ];
      },
    },
  };
</script>
